export const EVENTS_METRICS_BAR_FILL =
	"var(--color-utility-brand-700, #175CD3)";
